module.exports = __webpack_public_path__ + "static/img/logo46.a7d0f49.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo46.png
// module id = /CBd
// module chunks = 1